var $b4c8fc2d07b9421e$exports = {};
// 使用 import 语句引入图标文件
// https://static.ecipc.cn/icon.png
function $b4c8fc2d07b9421e$var$setFavicon(iconUrl) {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'shortcut icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = iconUrl;
}
window.addEventListener('DOMContentLoaded', ()=>{
    $b4c8fc2d07b9421e$var$setFavicon('https://static.ecipc.cn/icon.png');
}); //js动态设置浏览器标签icon https://static.ecipc.cn/icon.png


//# sourceMappingURL=a.785c71dc.js.map
